import { motion } from "framer-motion";
import { FaLock } from "react-icons/fa";


const AccessDenied = () => {
  

  return (
    <div className="flex items-center justify-center h-full bg-gradient-to-br from-red-50 to-white">
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 30 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="bg-white shadow-xl border border-red-100 rounded-2xl p-8 max-w-md text-center"
      >
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="bg-red-100 text-red-500 p-4 rounded-full shadow-inner">
            <FaLock size={28} />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl font-semibold text-gray-800">
          Access Restricted
        </h2>

        {/* Message */}
        <p className="text-gray-500 mt-2 text-sm leading-relaxed">
          You don’t have permission to view this page.  
          Please contact your administrator or go back to a safe area.
        </p>
      </motion.div>
    </div>
  );
};

export default AccessDenied;